import React from 'react';
import moment from 'moment';
import {BackgroundImage, Image, AuthMenu, Button, AuthToggle, Growls} from '../components';
import {images, menus, routes, accountConstants} from '../constants';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { NavActions, AuthActions } from '../actions';

const { roles, loginStates } = accountConstants;

class Navigator extends React.Component {
    constructor(props){
        super(props);

        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    }

    componentWillMount() {
        if (this.props.activeUser.loginState === loginStates.UNVALIDATED) {
            this.props.dispatch(AuthActions.refreshToken(this.props.activeUser));
        }
    }

    toggleMobileMenu() {
        this.props.dispatch(NavActions.menuToggle());
    }

    logOut(){
        this.props.dispatch(AuthActions.logOut(this.props.activeUser));
        browserHistory.push(routes.LOGIN);
    }

    render() {
        let menuOpenClass = this.props.menuToggleState ? ' menu-open' : '';
        let currentYear = moment().format('YYYY');

        return (
            <div className="app" id="container-navigator">
                <header className="app-header">
                    <div className="mobile-menu-head">
                        <div className="mobile-menu-controls">
                            <Link to={routes.HOME}>
                                <Image className="mobile-logo" src={images.APP_LOGO_SMALL}/>
                            </Link>
                            <Button onClick={this.toggleMobileMenu} className="mobile-menu-button">Menu</Button>
                        </div>
                    </div>
                    <div className="menu-sticky-fill"></div>
                    <div className={'menu-body' + menuOpenClass}>
                        <div className="container menu-wrapper">
                            <div className="row">
                                <div className="col-sm-2">
                                    <Link to={routes.HOME}>
                                        <div className="desktop-logo-wrapper">
                                            <BackgroundImage src={images.APP_LOGO} className="header-logo aspect"/>
                                        </div>
                                    </Link>
                                </div>
                                <div className="nav-actions col-sm-10">
                                    <AuthToggle userIsAuthorized={user => { return user.roles === roles.ADMIN }}>
                                        <Button className="desktop-only-inline-block" to={routes.USER_MANAGEMENT}>Admin</Button>
                                    </AuthToggle>
                                    <AuthToggle userIsAuthorized={user => { return user.roles != roles.NONE }}>
                                        <Button to={routes.ACCOUNT}>Account Settings</Button>
                                        <Button onClick={() => this.logOut()}>Log Out</Button>
                                    </AuthToggle>
                                    <AuthToggle userIsAuthorized={user => { return user.roles === roles.NONE }}>
                                        <Button to={routes.LOGIN} className="primary">Log In / Create Account</Button>
                                    </AuthToggle>
                                </div>
                            </div>
                            <div className="row">
                                <AuthMenu user={this.props.activeUser} className="col-sm-12" items={menus.MAIN} appState={this.props.appState} />
                            </div>
                        </div>
                    </div>
                </header>
                <div className={'app-body' + menuOpenClass}>
                    <Growls growls={this.props.growls} />
                    { this.props.children }
                </div>
                <footer className="app-footer row">
                    <div className="col-sm-12 center">
                        <p>
                            Copyright &copy; { currentYear } Oil Services Laboratory
                        </p>
                    </div>
                </footer>
            </div>
        )
    }
}

function select(state) {
    return {
        appState: state.appState.currentRoute,
        menuToggleState: state.menuToggleState,
        activeUser: state.activeUser,
        growls: state.growlList
    }
}

export default connect(select)(Navigator);



// WEBPACK FOOTER //
// ./web-app/containers/navigator.jsx